import { useCleanseApp } from "./state/useCleanseApp";
import { Sidebar } from "./components/Sidebar";
import { MainContent } from "./components/MainContent";
import { ConfirmDialog } from "./components/ConfirmDialog";

export default function App() {
  const app = useCleanseApp();
  const {
    mode,
    setMode,
    mapping,
    csv,
    apiKey,
    setApiKey,
    apiKeyValid,
    validatingApiKey,
    proc,
    recovery,
    error,
    showConfirmDialog,
    canProcess,
    outputHeaders,
    handleKeyDown,
    handleFile,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    resumeFromCrash,
    processAll,
    handleDownload,
    startNewCleanse,
    handleConfirmNewCleanse,
  } = app;

  return (
    <div className="min-h-screen flex">
      <Sidebar
        mode={mode}
        setMode={setMode}
        rows={csv.rows}
        csvHeaders={csv.csvHeaders}
        uploadedFileName={csv.uploadedFileName}
        isDragOver={csv.isDragOver}
        handleFile={handleFile}
        handleDragOver={handleDragOver}
        handleDragLeave={handleDragLeave}
        handleDrop={handleDrop}
        error={error}
        hasRecoveryData={recovery.hasRecoveryData}
        resumeFromCrash={resumeFromCrash}
        clearRecovery={recovery.clear}
        line1Col={mapping.line1Col}
        postcodeCol={mapping.postcodeCol}
        uprnCol={mapping.uprnCol}
        setLine1Col={mapping.setLine1Col}
        setPostcodeCol={mapping.setPostcodeCol}
        setUprnCol={mapping.setUprnCol}
        apiKey={apiKey}
        setApiKey={setApiKey}
        apiKeyValid={apiKeyValid}
        validatingApiKey={validatingApiKey}
        processing={proc.processing}
        canProcess={canProcess}
        processAll={processAll}
        cancelProcessing={proc.cancel}
        handleKeyDown={handleKeyDown}
      />

      <MainContent
        mode={mode}
        processing={proc.processing}
        paused={proc.paused}
        progress={proc.progress}
        resultRows={proc.resultRows}
        rows={csv.rows}
        csvHeaders={csv.csvHeaders}
        line1Col={mapping.line1Col}
        postcodeCol={mapping.postcodeCol}
        uprnCol={mapping.uprnCol}
        outputHeaders={outputHeaders}
        error={error}
        handleDownload={handleDownload}
        startNewCleanse={startNewCleanse}
        handleKeyDown={handleKeyDown}
      />

      <ConfirmDialog
        show={showConfirmDialog}
        onConfirm={handleConfirmNewCleanse}
        handleKeyDown={handleKeyDown}
      />
    </div>
  );
}
